const serviceMenuItems = [
  {
    to: '/services/web-development/',
    label: 'Web Development India',
  },
  {
    to: '/services/website-development-company-aravalli/',
    label: 'Web Development Aravalli',
  },
  {
    to: '/services/software-development/',
    label: 'Software Development',
    children: [
      {
        to: '/services/software-development-modasa/',
        label: 'Software Development Modasa',
      },
    ],
  },
  {
    to: '/services/mobile-app-development/',
    label: 'Mobile App Development',
    children: [
      {
        to: '/services/mobile-app-development-modasa/',
        label: 'Mobile App Development Modasa',
      },
    ],
  },
  {
    to: '/services/ai-agent-development/',
    label: 'AI Agent Development',
  },
  {
    to: '/services/digital-marketing-services/',
    label: 'Digital Marketing Services',
    children: [
      {
        to: '/services/digital-marketing-modasa/',
        label: 'Digital Marketing Modasa',
      },
      {
        to: '/services/seo-service/',
        label: 'SEO Service',
      },
      {
        to: '/services/google-ads/',
        label: 'Google Ads',
      },
      {
        to: '/services/social-media-marketing/',
        label: 'Social Media Marketing',
      },
      {
        to: '/services/content-writing-services/',
        label: 'Content Writing Services',
      },
    ],
  },
  {
    to: '/services/hire-chrome-extension-developer/',
    label: 'Hire Chrome Extension Developer',
  },
  {
    to: '/services/crm-development/',
    label: 'CRM System',
  },
  {
    to: '/services/whatsapp-crm-aravalli/',
    label: 'WhatsApp CRM Aravalli',
  },
  {
    to: '/services/qa-testing/',
    label: 'QA Testing',
  },
  {
    to: '/services/erp-development/',
    label: 'ERP System',
  },
  {
    to: '/services/website-development-modasa/',
    label: 'Website Development Modasa',
  },
];

export const flattenServiceMenuItems = (items = serviceMenuItems) =>
  items.flatMap((item) => [item, ...(item.children || [])]);

export default serviceMenuItems;
